import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const updateRule=(id,statement,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.UPDATE_RULE_START
    })
    const options={
        url:`${api}/rules/${id}`,
        method:'PUT',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{statement}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.UPDATE_RULE_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.UPDATE_RULE_FAIL,
                payload:getMessage(error)
            }))
}